import { useState, useEffect } from 'react';
import { db, auth } from '../firebase';
import { collection, query, where, getDocs, addDoc, serverTimestamp } from 'firebase/firestore';
import { useNavigate } from 'react-router-dom';
import { useParams } from 'react-router-dom';
import './SpaceApp.css';
const SpaceHome = () => {
  const [spaces, setSpaces] = useState([]);
  const { username } = useParams();
  const navigate = useNavigate();

  useEffect(() => {
    const fetchSpaces = async () => {
      const q = query(
        collection(db, "spaces"), 
        where("memberIds", "array-contains", auth.currentUser.uid)
      );
      const snap = await getDocs(q);
      setSpaces(snap.docs.map(d => ({ id: d.id, ...d.data() })));
    };
    fetchSpaces();
  }, []);

  const createNewSpace = async () => {
    const name = prompt("Name your new Team Space:");
    if (!name) return;

    try {
    const docRef = await addDoc(collection(db, "spaces"), {
      name,
      ownerId: auth.currentUser.uid,
      memberIds: [auth.currentUser.uid],
      memberEmails: [auth.currentUser.email.toLowerCase()],
      settings: { allowAllCreate: true, allowAllEdit: true },
      createdAt: serverTimestamp()
    });

    // 🌟 FIX: Use the username from the URL parameters to navigate correctly
    // Do NOT use window.location.reload()
    navigate(`/${username}/spaces/${docRef.id}`); 
    
  } catch (err) {
    console.error("Error creating space:", err);
  }
};
  /* Inside SpaceHome.js */
return (
  <div className="spaces-container" style={{ padding: '60px', maxWidth: '1200px', margin: '0 auto', minHeight: '100vh', background: '#0a0a0a' }}>
    <header style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', borderBottom: '4px solid #D90429', paddingBottom: '20px' }}>
      <h1 style={{ fontSize: '3.5rem', margin: 0, color: '#ffffff', fontFamily: "'Syne', sans-serif", fontWeight: '800' }}>
        TeamFlow / <span style={{ color: '#D90429' }}>Spaces</span>
      </h1>
      <button onClick={createNewSpace} className="red-button-rustic">INITIATE NEW SPACE</button>
    </header>

    <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(320px, 1fr))', gap: '30px', marginTop: '60px' }}>
      {spaces.map(space => (
        <div 
          key={space.id} 
          className="space-card-rustic" 
          onClick={() => navigate(`/${username}/spaces/${space.id}`)}
        >
          {/* Subtle background initial for texture */}
          <div className="card-bg-letter">{(space.name || "S")[0]}</div>
          
          <div className="card-content">
            <h3 style={{ fontSize: '1.8rem', margin: '0 0 10px 0', color: '#ffffff', fontFamily: "'Syne', sans-serif" }}>
              {space.name.toUpperCase()}
            </h3>
            <p style={{ color: '#a0a0a0', fontWeight: '600', letterSpacing: '1px' }}>
              {space.memberIds.length} COLLABORATORS
            </p>
          </div>
          
          <div className="go-arrow-rustic">GO TO SPACE →</div>
        </div>
      ))}
    </div>

    <style>{`
      .red-button-rustic {
        background: #D90429;
        color: white;
        border: 2px solid #D90429;
        padding: 15px 35px;
        font-family: 'Syne', sans-serif;
        font-weight: 800;
        cursor: pointer;
        transition: all 0.2s ease;
      }
      .red-button-rustic:hover {
        background: white;
        color: #0a0a0a;
      }
      .space-card-rustic {
        background: #1a1a1a;
        border: 2px solid #333;
        padding: 40px;
        position: relative;
        cursor: pointer;
        overflow: hidden;
        transition: all 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275);
      }
      .space-card-rustic:hover {
        border-color: #D90429;
        transform: translateY(-5px);
      }
      .card-bg-letter {
        font-size: 8rem;
        font-weight: 900;
        color: rgba(217, 4, 41, 0.07); /* Subtle Red tint */
        position: absolute;
        bottom: -20px;
        right: -10px;
        pointer-events: none;
      }
      .go-arrow-rustic {
        margin-top: 25px;
        color: #D90429;
        font-weight: 800;
        font-size: 0.9rem;
        letter-spacing: 2px;
      }
    `}</style>
  </div>
);
};

export default SpaceHome;
